module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.12/_next/static/images/validador-boleto-3dfafa9b8f46b8dfdaba555502ad7888.gif";